import React, { useState } from 'react';
import {Form} from "@heroui/form";
import {Button} from "@heroui/button";
import {Input} from "@heroui/input";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@heroui/modal";

const NewPasswordForm = ({cancelLogin, setuser, dismissModal}) => {
  const [password, setPassword] = useState();
  const [confirmPw, setConfirmPw] = useState();
  const [error, setError] = useState();
  // TODO -= get token from params. 
  const params = new URLSearchParams(window.location.search);

  const doSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPw) {
      setError("Passwords do not match.");
      return;
    }
    let fd = new FormData();
    fd.append('new_password', password);
    fd.append('new_password_confirm', confirmPw);
    fd.append('token', params.get('reset_token'));
    const d = await fetch('/api/v1/users/new_password', {method: 'POST', body: fd});
    if (d?.status !== 200) {
      // Failure. You. Failure.
      setError('Something went wrong.');
      return false;
    } else {
      // New password success... 
      alert('Password changed successfully. You will need to reauthenticate with your new password.');
      window.location.href = '/';
      return true;
    }
  };

  return (
    <Modal placement='top' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={dismissModal}>
      <ModalContent>
        <ModalHeader>
          Update your password
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={doSubmit}
                className="w-full max-w-xs flex flex-col gap-4">
            <div className='error-header'>
              {error}
            </div>
            <Input isRequired label='New password'
                   type="password"
                   variant='bordered'
                   validationBehavior='native'
                   placeholder=''
                   onChange={(d) => setPassword(d.target.value)}
            />
            <Input isRequired label='Confirm new password'
                   validationBehavior='native'
                   fullWidth='true'
                   type="password"
                   variant="bordered"
                   onChange={(d) => setConfirmPw(d.target.value)}
            />
            <div className="flex gap-4 items-center" style={{paddingBottom: '8px'}}>
              <Button type='submit' onPress={cancelLogin}>Cancel</Button>
              <Button color='success' type='submit'>Submit</Button>
              <a style={{fontSize: '14px', color: '#1888f0'}} href='https://activistmailer.com/support-page/'>Support</a>
            </div>
          </Form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default NewPasswordForm;
